import { BellRing, Boxes, Printer } from 'lucide-react'

import { defineModule } from '@/lib/module-routes'
import { AGENT_PERMISSIONS, HIERARCHY_PERMISSIONS, PERMISSION_KEYS } from '@/lib/permissions'

import { entityAssetsRoute, entityUnrecognizedAssetsRoute, entityAssetDetailRoute, entityAssetNetworkRoute, entityAssetSecurityRoute, entityAssetFirewallRulesRoute, entityAssetManagementRoute, entityAssetSourceRoute, entityAssetSettingsRoute, entityAssetSuppliesRoute, entityPrintSettingsRoute, entityAlertRulesRoute, entityAlertRuleDetailRoute } from './routes'

import { assetHomeWidgets } from './home-widgets'

export const assetsModule = defineModule({
  widgets: assetHomeWidgets,
  routes: [
    entityAssetsRoute,
    entityUnrecognizedAssetsRoute,
    entityAssetDetailRoute,
    entityAssetNetworkRoute,
    entityAssetSecurityRoute,
    entityAssetFirewallRulesRoute,
    entityAssetManagementRoute,
    entityAssetSourceRoute,
    entityAssetSettingsRoute,
    entityAssetSuppliesRoute,
    entityPrintSettingsRoute,
    entityAlertRulesRoute,
    entityAlertRuleDetailRoute,
  ],
  sections: {
    dataCollection: [{ id: 'assets', label: 'Assets', order: 20 }],
  },
  navigation: {
    dataCollection: [
      {
        to: '/$entityId/assets',
        label: 'Assets',
        icon: Boxes,
        permission: AGENT_PERMISSIONS.read,
        section: 'assets',
        order: 10,
      },
    ],
    settings: [
      {
        to: '/$entityId/settings/print',
        label: 'Print',
        icon: Printer,
        permission: HIERARCHY_PERMISSIONS.read,
        section: 'settings',
        order: 35,
      },
      {
        to: '/$entityId/settings/alert-rules',
        label: 'Alert rules',
        icon: BellRing,
        permission: PERMISSION_KEYS.alertRead,
        section: 'settings',
        order: 37,
      },
    ],
  },
})
